var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white py-5 mt-4 text-center"},[_c('small',[_vm._v("© "+_vm._s(new Date().getFullYear())+" LES. Alle rechten voorbehouden. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }